// src/api/apiProvider.ts

import axios, { AxiosInstance } from 'axios';
import { logoutUser } from 'src/auth/auth-helper';
import { Toast } from 'antd-mobile'; // or your preferred UI library

const apiProvider: AxiosInstance = axios.create({});

apiProvider.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      if (error.code === 'ECONNABORTED' && error.message.includes('TIMEOUT')) {
        Toast.show({ content: 'Request timed out. Please try again.' });
      } else if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
        Toast.show({ content: 'No internet connection. Check your network.' });
      }
      return Promise.reject(error);
    }

    const { status } = error.response;
    if (status === 400 ){
      Toast.show({
        content: 'Oops! Something went wrong. Please try again later.',
        duration: 3000,
        position: 'center',
        maskClickable: true,
      });
    }
    if (status === 401) {
      logoutUser();
      Toast.show({ content: 'Session expired. Please log in again.',duration: 3000,
        position: 'center',
        maskClickable: true });
    }

    if (status === 500) {
      Toast.show({
        content: 'Oops! Something went wrong. Please try again later.',
        duration: 3000,
        position: 'center',
        maskClickable: true,
      });
      // window.location.href = '/error';
    }

    
    return Promise.reject(error);
  },
);

const apiProviderSkipGenericErrors = axios.create({});

apiProviderSkipGenericErrors.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      if (error.code === 'ECONNABORTED' && error.message.includes('TIMEOUT')) {
        Toast.show({ content: 'Request timed out. Please try again.' });
      } else if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
        Toast.show({ content: 'No internet connection. Check your network.' });
      }
      return Promise.reject(error);
    }

    const { status } = error.response;
    if (status === 401) {
      logoutUser();
      Toast.show({ content: 'Session expired. Please log in again.',duration: 3000,
        position: 'center',
        maskClickable: true });
    }

    return Promise.reject(error);
  },
);

export { apiProvider, apiProviderSkipGenericErrors };
